// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"298ace11","453":"722d2218","455":"2f1c947a","977":"b4daa1bf"}[chunkId] + ".chunk.js";
};